import React, { ChangeEvent } from 'react';

import { GeneralConstants } from 'app/constants';
import { Brand, KnpPaginationData } from 'app/model';
import { searchService } from 'app/services';
import { EntityOnChange } from 'app/type';

import { DelayedSearch, DelayedSearchProps } from './delayed-search';

interface CrisBrandPickerProps
    extends Omit<
        DelayedSearchProps<Brand, false>,
        | 'freeSolo'
        | 'getOptionLabel'
        | 'isOptionEqualToValue'
        | 'mapDataToOptions'
        | 'onChange'
        | 'onSearch'
        | 'value'
        | 'variant'
    > {
    name?: string;
    value?: Brand;
    size?: 'medium' | 'small';
    /** @deprecated has no effect */
    up?: boolean;

    onChange: EntityOnChange<unknown, Brand | undefined>;
}

/**
 * TODO reafactor this cris-entity-picker and store-picker, lots of similar code?
 */
export class CrisBrandPicker extends React.Component<CrisBrandPickerProps> {
    public render(): React.ReactNode {
        const { onChange, ...rest } = this.props;

        const handleEntityChange = (evt: ChangeEvent<{ name?: string; value: unknown }>, value?: Brand): void => {
            onChange(evt, evt.target.name as never, value);
        };

        return (
            <DelayedSearch
                label='Pick A Brand'
                {...rest}
                freeSolo={false}
                onChange={handleEntityChange}
                value={this.props.value ?? GeneralConstants.COMPONENT_VALUE_NULL}
                variant='standard'
                onSearch={(data) => searchService.search(data, 1, GeneralConstants.PAGE_SIZE_LARGE)}
                mapDataToOptions={(data: KnpPaginationData<Brand>) => data.data}
                getOptionLabel={(data) => `${data?.name ?? ''}`}
                isOptionEqualToValue={(option) => option.id === this.props.value?.id}
            />
        );
    }
}
